const iciciElevateAddons = [
  {
    addon_title: "Critical Illness",
    addon_desc: "Critical Illness – Covers life-threatening illnesses such as cancer, heart attack, stroke, and major organ transplant, providing a lump sum benefit upon diagnosis to help with medical and lifestyle expenses.",
    addon_id: "CI",
    addon_conditions: ["age > 18", "age <= 50"],
    showMembers: false,
  },
  {
    addon_title: "Annual health check up",
    addon_desc: "Provides a yearly preventive health examination to monitor overall wellness, detect potential health issues early, and encourage timely medical intervention.",
    addon_id: "AHC",
    addon_conditions: ["age > 18"],
    showMembers: false,
  },
  {
    addon_title: "Domestic Air Ambulance",
    addon_desc: "Covers the cost of air ambulance services within India for emergency medical transportation to the nearest hospital equipped to provide necessary treatment.",
    addon_id: "DAA",
    addon_conditions: [],
    showMembers: false,
  },
  {
    addon_title: "Dependent accommodation benefit",
    addon_desc: "Covers expenses for the accommodation of an immediate family member or dependent when the insured is hospitalized, ensuring their presence and support during treatment.",
    addon_id: "DAB",
    addon_conditions: [],
    showMembers: false,
  },
  {
    addon_title: "Convalescence benefit",
    addon_desc: "Provides a lump sum payment to support recovery and incidental expenses when hospitalization extends beyond a specified period due to illness or injury.",
    addon_id: "CB",
    addon_conditions: [],
    showMembers: false,
  },
  {
    addon_title: "Durable medical equipment cover",
    addon_desc: "Covers the cost of prescribed medical equipment such as wheelchairs, oxygen concentrators, or walkers, essential for the insured’s treatment and recovery.",
    addon_id: "DMEC",
    addon_conditions: [],
    showMembers: false,
  },
  {
    addon_title: "Worldwide Cover",
    addon_desc: "Provides coverage for medical treatment expenses incurred outside India, ensuring protection against unforeseen illnesses or injuries during international travel.",
    addon_id: "WC",
    addon_conditions: [],
    showMembers: false,
  },
  {
    addon_title: "Personal Accident",
    addon_desc: "Offers financial protection by providing a lump sum benefit in case of death or permanent disability resulting from an accident.",
    addon_id: "PA",
    addon_conditions: ["age<= 65"],
    showMembers: false,
  },
  {
    addon_title: "Sum Insured Protector",
    addon_desc: "Adjusts the policy’s sum insured annually in line with inflation, helping maintain adequate coverage against rising medical costs.",
    addon_id: "SIP",
    addon_conditions: [],
    showMembers: false,
  },
  {
    addon_title: "Claims Protector",
    addon_desc: "Covers items listed as non-payable by the Insurance Regulatory and Development Authority of India (IRDAI) on policies where the sum insured is less than Rs 15 lakhs. It allows you to make claims for these non-payable items if a claim has been accepted for in-patient hospitalization.",
    addon_id: "CP",
    addon_conditions: [],
    showMembers: false,
  },
  {
    addon_title: "Infinite Care",
    addon_desc: "It provides unlimited coverage for a single, selected claim during the entire lifetime of the policy. The add-on covers hospitalization expenses such as in-patient treatment, day care procedures, and in-patient AYUSH hospitalization, without any limits on the annual sum insured for that specific claim. It is important to note that this add-on can only be used once and must be opted for within the first two policy years.",
    addon_id: "IC",
    addon_conditions: [],
    showMembers: false,
  },
  {
    addon_title: "Compassionate_Visit_HP",
    addon_desc: "It covers the travel costs, such as an economy class air ticket, for an immediate family member to visit an insured person who has been hospitalized for more than a specific number of days. The maximum reimbursement is determined by the plan's terms.",
    addon_id: "CV",
    addon_conditions: [],
    showMembers: false,
  },
  {
    addon_title: "Nursing_at_Home_HP",
    addon_desc: "This add-on provides coverage for medically necessary nursing services delivered at the insured person’s home, when such care is prescribed by a registered medical practitioner after a hospitalization. It ensures you have access to qualified nurses for continued recovery, without the need for extended hospital stays, helping reduce costs and improve comfort during recuperation.",
    addon_id: "NH",
    addon_conditions: [],
    showMembers: false,
  },
  {
    addon_title: "BeFit_A_HP",
    addon_desc: "A preventive care package designed to promote overall health and wellness. It includes annual or periodic health check-ups, access to teleconsultations with general physicians, and basic lifestyle guidance. The focus is on early detection of potential health issues, empowering you to take timely preventive measures.",
    addon_id: "BEFITA",
    addon_conditions: [],
    showMembers: false,
  },
  {
    addon_title: "BeFit_B_HP",
    addon_desc: "A healthcare access benefit offering doctor consultations (either physical or virtual), diagnostic lab testing, and discounts or allowances for prescribed medicines. It aims to make routine healthcare more accessible and cost-effective, reducing the burden of everyday medical expenses.",
    addon_id: "BEFITB",
    addon_conditions: [],
    showMembers: false,
  },
  {
    addon_title: "BeFit_C_HP",
    addon_desc: "A wellness-oriented cover that encourages healthy living through fitness programs, dietary consultations, and preventive screenings. The plan promotes an active lifestyle and helps monitor key health parameters to prevent chronic illnesses.",
    addon_id: "BEFITC",
    addon_conditions: [],
    showMembers: false,
  },
  {
    addon_title: "BeFit_D_HP",
    addon_desc: "This benefit is tailored for recovery and rehabilitation. It covers physiotherapy sessions, post-injury or post-surgery rehabilitation, and guided exercise programs prescribed by medical experts, ensuring a faster and safer return to normal activity.",
    addon_id: "BEFITD",
    addon_conditions: [],
    showMembers: false,
  },
  {
    addon_title: "BeFit_E_HP",
    addon_desc: "Focused on mental well-being, this plan offers coverage for counseling sessions and therapy conducted by licensed mental health professionals. It supports stress management, anxiety or depression treatment, and general emotional wellness.",
    addon_id: "BEFITE",
    addon_conditions: [],
    showMembers: false,
  },
  {
    addon_title: "BeFit_F_HP",
    addon_desc: "A lifestyle management cover that provides access to certified nutritionists, personalized diet planning, and structured wellness programs. It aims to help you achieve and maintain optimal health through sustainable lifestyle changes.",
    addon_id: "BEFITF",
    addon_conditions: [],
    showMembers: false,
  },
  {
    addon_title: "BeFit_G_HP",
    addon_desc: "Designed for people living with long-term medical conditions, this benefit covers ongoing disease management, regular monitoring, and medical support for chronic illnesses such as diabetes, hypertension, or heart disease.",
    addon_id: "BEFITG",
    addon_conditions: [],
    showMembers: false,
  },
  {
    addon_title: "Waiting Period",
    addon_desc: "The period starting from the policy commencement date during which certain specified diseases, treatments, or pre-existing conditions are not covered. Once this duration is over (subject to continuous renewal), the related benefits become claimable as per policy terms.",
    addon_id: "WP",
    addon_conditions: [],
    showMembers: false,
  },
  {
    addon_title: "Senior care plan A",
    addon_desc: "A basic senior health package covering regular health check-ups, access to general physicians, pharmacy benefits, and essential diagnostic services. It is intended to support everyday healthcare needs of older adults.",
    addon_id: "SCA",
    addon_conditions: ["age >= 55"],
    showMembers: false,
  },
  {
    addon_title: "Senior care plan B",
    addon_desc: "An enhanced senior plan providing specialist doctor consultations, a broader range of diagnostic tests, and home healthcare visits, offering better convenience and medical oversight for the elderly.",
    addon_id: "SCB",
    addon_conditions: ["age >= 55"],
    showMembers: false,
  },
  {
    addon_title: "Senior care plan C",
    addon_desc: " A comprehensive care plan for seniors that includes regular health monitoring, dedicated nursing support, and management of chronic conditions. It’s designed for those needing more frequent and personalized medical attention.",
    addon_id: "SCC",
    addon_conditions: ["age >= 55"],
    showMembers: false,
  },
  {
    addon_title: "Senior care plan D",
    addon_desc: "A premium-level senior care package with the widest range of benefits, including advanced diagnostics, priority specialist access, at-home medical visits, and wellness programs. It’s ideal for seniors seeking top-tier healthcare services with added comfort and convenience.",
    addon_id: "SCD",
    addon_conditions: ["age >= 55"],
    showMembers: false,
  },
  {
    addon_title: "Maternity cover",
    addon_desc:
      "This optional benefit covers the medical expenses up to 10% of the Annual Sum Insured; subject to a maximum limit of INR 1 Lakhs (Sum Insured) for the delivery of a baby and / or expenses related to medically recommended lawful termination of pregnancy but only in life threatening situation under the advice of Medical Practitioner, limited to maximum of three deliveries or terminations as said herein during the lifetime of an female Insured/Insured Person as the case may be between the ages of 18 years to 45 years in the Policy.",
    test: true,
    addon_id: "MA",
    addon_conditions: ["age > 18", "age <= 45", "gender=='FEMALE'"],
    showMembers: false,
  },
  {
    addon_title: "New Born Baby Cover",
    addon_desc:
      "We will cover the Medical Expenses incurred by the Insured Person on Hospitalization of a 'New born Baby' during each Policy Year of Policy Period subject to the maximum limit of twice of the maternity sum Insured. This limit is over and above the maternity sum insured. This Optional Cover will cover Medical Expenses incurred on the “New born Baby” during Hospitalization (for a minimum period of consecutive 24 hours) for a maximum period up to 90 days from the date of birth of the baby",
    test: true,
    addon_id: "NB",
    addon_conditions: ["age > 18", "age <= 45", "gender=='FEMALE'"],
    showMembers: false,
  },
  {
    addon_title: "Vaccination for New Born Baby",
    addon_desc:
      "We will cover the expenses incurred on Vaccinations of the new born baby till one year of age during the policy period up to 1% of the Sum Insured subject to a maximum limit of INR 10,000. This limit is over and above the Maternity Sum Insured.",
    addon_id: "VAC",
    addon_conditions: ["age > 18", "age <= 45", "gender=='FEMALE'"],
    showMembers: false,
  },
];
const befitelevateAddonIds = [
  "BEFITG",
  "BEFITF",
  "BEFITE",
  "BEFITD",
  "BEFITC",
  "BEFITB",
  "BEFITA",
];
const seniorCarePlan = ["SCD", "SCC", "SCB", "SCA"];
export { seniorCarePlan, befitelevateAddonIds, iciciElevateAddons };
